(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const init = (root) => {
    if (root.dataset.p4mReady === 'true') return;
    root.dataset.p4mReady = 'true';

    const grid = root.querySelector('[data-p4m-bike-grid]');
    const cards = Array.from(root.querySelectorAll('[data-p4m-bike-card]'));
    const categoryButtons = Array.from(root.querySelectorAll('[data-p4m-category]'));
    const searchInput = root.querySelector('[data-p4m-bike-search]');
    const sortSelect = root.querySelector('[data-p4m-bike-sort]');
    const availabilityInput = root.querySelector('[data-p4m-bike-available]');
    const resultCount = root.querySelector('[data-p4m-bike-result-count]');
    const emptyState = root.querySelector('[data-p4m-bike-empty]');

    if (!grid || cards.length === 0) return;

    let activeCategory = 'all';

    const apply = () => {
      const query = normalize(searchInput?.value);
      const inStockOnly = Boolean(availabilityInput?.checked);
      let visible = 0;

      cards.forEach((card) => {
        const categoryMatch = activeCategory === 'all' || card.dataset.category === activeCategory;
        const queryMatch = !query || normalize(card.dataset.search).includes(query);
        const availabilityMatch = !inStockOnly || card.dataset.available === 'true';
        const show = categoryMatch && queryMatch && availabilityMatch;
        card.hidden = !show;
        if (show) visible += 1;
      });

      const visibleCards = cards.filter((card) => !card.hidden);
      const hiddenCards = cards.filter((card) => card.hidden);
      const sort = sortSelect?.value || 'featured';
      visibleCards.sort((left, right) => {
        if (sort === 'price-ascending') return Number(left.dataset.price) - Number(right.dataset.price);
        if (sort === 'price-descending') return Number(right.dataset.price) - Number(left.dataset.price);
        if (sort === 'title-ascending') return normalize(left.dataset.title).localeCompare(normalize(right.dataset.title));
        return Number(left.dataset.index) - Number(right.dataset.index);
      });
      [...visibleCards, ...hiddenCards].forEach((card) => grid.append(card));

      if (resultCount) resultCount.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
      if (emptyState) emptyState.hidden = visible !== 0;
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.p4mCategory || 'all';
        categoryButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
        apply();
        root.querySelector('[data-p4m-bike-products]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    searchInput?.addEventListener('input', apply);
    sortSelect?.addEventListener('change', apply);
    availabilityInput?.addEventListener('change', apply);
    apply();
  };

  const initAll = () => document.querySelectorAll('[data-p4m-bike-storefront]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
